import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Components
import { RvDraggableComponent } from './components/rv-draggable/rv-draggable.component';

// Directives
import { RvDraggableItemDirective } from './directives/rv-draggable-item.directive';
import { RvDroppableItemDirective } from './directives/rv-droppable-item.directive';
import { RvDraggableHandleDirective } from './directives/rv-draggable-handle.directive';

@NgModule({
  declarations: [
    RvDraggableComponent,
    RvDraggableItemDirective,
    RvDroppableItemDirective,
    RvDraggableHandleDirective,
  ],
  imports: [CommonModule],
  exports: [
    RvDraggableComponent,
    RvDraggableItemDirective,
    RvDroppableItemDirective,
    RvDraggableHandleDirective,
  ],
  providers: [
    // RvDraggableService is not provided here as it's instantiated directly in components
  ],
})
export class RvDraggableModule {}
